import React from 'react';
import PropTypes from 'prop-types';
import {compose, setPropTypes, lifecycle} from 'recompose';

const {PARTNER} = process.env;

const Iframe = ({track}) => (
  <iframe
    title="repl"
    height="400px"
    width="100%"
    src={`https://repl.it/@Barmej/${track}?lite=true`}
    scrolling="no"
    frameBorder="no"
    allowtransparency="true"
    allowFullScreen="true"
    sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-modals"
  />
);

Iframe.propTypes = {
  track: PropTypes.string,
};

const enhance = compose(
  setPropTypes({
    stepId: PropTypes.number.isRequired,
  }),
  lifecycle({
    componentDidMount() {
      const {stepId} = this.props;
      const replEventName = PARTNER === 'BARMEJ' ? 'Repl' : `${PARTNER} Repl`;

      if (window && window.mixpanel) {
        window.mixpanel.track(replEventName, {
          'Step Id': stepId,
        });
      }

      if (typeof window !== 'undefined') {
        if (window.dataLayer) {
          window.dataLayer.push({
            replEventName,
            stepId: `Step Id : ${stepId}`,
            event: 'Repl Event',
          });
        }
      }
    },
  }),
);

export default enhance(Iframe);
